var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup335762(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 68,
    viewBox: "0 0 81 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 68,
    fill: "#7399EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0141 37.1555C37.2474 36.3902 36.7808 35.3502 36.7808 34.1835C36.7808 31.8462 38.6634 29.9622 40.9994 29.9622C42.1554 29.9622 43.2194 30.4302 43.9728 31.1955",
    stroke: "#002766",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.14 34.9316C44.8307 36.6516 43.476 38.009 41.7573 38.321",
    stroke: "#002766",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8727 41.2962C31.7567 39.6349 29.9647 37.2082 28.666 34.1829C29.978 31.1442 31.782 28.7042 33.9113 27.0296C36.0273 25.3549 38.4687 24.4456 40.9993 24.4456C43.5447 24.4456 45.9847 25.3682 48.114 27.0549",
    stroke: "#002766",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9297 29.9875C51.847 31.2062 52.6537 32.6129 53.3324 34.1822C50.7097 40.2582 46.075 43.9182 40.999 43.9182C39.8484 43.9182 38.7137 43.7315 37.623 43.3675",
    stroke: "#002766",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5159 23.666L30.4839 44.698",
    stroke: "#002766",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup335762);
export default __webpack_public_path__ + "static/media/Group 33576 (2).30f30906416c641dff218ed5f5e12a4e.svg";
export { ForwardRef as ReactComponent };